import icon from "@material-ui/icons/MonetizationOn";

export const InvoiceIcon = icon;

export default {
  icon
};
